<div [formGroup]="fg">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'playbooks.sendToSocActionDisplayName' | labelsProvider }}
    </div>
    <div class="info-text">Select an adapter to route findings to the SOC platform.</div>
    <select
      class="action-setting-input"
      formControlName="adapterId"
      [ngClass]="{
        'input-form-invalid':
          fg.controls['adapterId'].invalid && (fg.controls['adapterId'].dirty || fg.controls['adapterId'].touched),
      }"
    >
      <option value="" disabled>Select an adapter</option>
      @for (adapter of adapters$ | async; track adapter.id) {
        <option [value]="adapter.id">{{ adapter.name }}</option>
      }
    </select>
  </div>
</div>
